import React, {Component} from 'react';
import classNames from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import banner from "assets/img/patents.jpg";
import * as text from './tc_text';
import profilePageStyle from "assets/jss/material-kit-react/views/profilePage.jsx";

class PatentsPage extends Component {
  renderPatentInfo(title, infoArray, link) {
    return (
      <div>
        {/* https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/ */}
        <a href={link} style={{display: "table-cell"}} target="_blank" rel="noopener noreferrer">
          <h3>{title}</h3>
        </a>
        {infoArray.map(txt => <p>{txt}</p>)}
      </div>
    );
  }

  render() {
    const {classes, history, auth, ...rest} = this.props;
    const B = (props) => <p style={{fontWeight:'bold'}}>{props.children}</p>;

    const p1title = 'First Patent Issued';
    const p1link = 'https://patents.google.com/patent/US9087321';
    const p1info = [
      'Patent No:  US 9087321B2',
      '2010-03-01 Priority to US30903810P',
      '2010-11-22 Application filed by TRINITY INTEL MEDIA LLC',
      '2011-09-01 Publication of US20110214068A1',
      '2015-07-21 Publication of US9087321B2',
      '2015-07-21 Application granted',
      '2033-08-27 Adjusted expiration',
    ];

    const p2title = 'Second Patent Issued';
    const p2link = 'https://patents.google.com/patent/US20150302100';
    const p2info = [
      'Patent No: US 20150302100A1',
      '2010-03-01 Priority to US30903810P',
      '2015-07-01 Application filed by TRINITY INTEL MEDIA LLC',
      '2015-10-22 Publication of US20150302100A1',
      '2016-01-05 Publication of US9230032B2',
      '2016-01-05 Application granted',
      '2030-11-22 Anticipated expiration',
    ];

    const p3title = 'Third Patent Issued';
    const p3link = 'https://patents.google.com/patent/US10019722B2/';
    const p3info = [
      'Patent No: US 10019722B2',
      '2010-03-01 Priority to US30903810P',
      '2016-01-04 Application filed by TRINITY INTEL MEDIA LLC',
      '2016-05-12 Publication of US20160132912A1',
      '2018-07-10 Publication of US10019722B2',
      '2018-07-10 Application granted',
      'Status Active',
      '2031-06-25 Adjusted expiration',
    ];

    const p4title = 'Fourth Patent Issued';
    const p4link = 'https://patents.google.com/patent/US20190012389A1/';
    const p4info = [
      'Patent No: US 20190012389A1',
      '2010-03-01 Priority to US30903810P',
      '2010-11-22 Priority to US12/951,332',
      '2015-07-01 Priority to US14/789,115',
      '2016-01-04 Priority to US14/987,447',
      '2018-07-02 Application filed by Trinity Info Media LLC',
      '2018-07-02 Priority to US16/025,840',
      '2019-01-10 Publication of US20190012389A1',
      '2020-12-08 Assigned to TRINITY INFO MEDIA, LLC',
      'Status Written approval',
    ];

    return (
      <div>
        <Header
          color="transparent"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{height: 200, color: "white"}}
          {...rest}
        />
        <Parallax small filter image={banner}>
          <div className={classes.titleContainer}>
            <h1 className={classes.tcppTitle}>Patents</h1>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.termsContainer}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={10}>
                  <div className={classes.profile}>
                    <div className={classes.name} style={{marginTop: 75}}>
                      <div style={{textAlign: 'left'}}>
                        <h2 style={{paddingTop: 15}}>Trinity Info Media Patents</h2>
                        <B>
                          Trinity Info Media, LLC is the owner of the below patents,
                          with the rightful ability to exercise and enforce the below patents:
                        </B>
                        {this.renderPatentInfo(p1title, p1info, p1link)}
                        {this.renderPatentInfo(p2title, p2info, p2link)}
                        {this.renderPatentInfo(p3title, p3info, p3link)}
                        {this.renderPatentInfo(p4title, p4info, p4link)}
                        <h3>Fifth Patent in conjunction and filed</h3>
                      </div>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const pageWithStyles = withStyles(profilePageStyle)(PatentsPage);

export default pageWithStyles;



// WEBPACK FOOTER //
// ./src/views/Patents.js